/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.printing").
controller("dxPrintSettingsController", function PrintSettingsController(
	DX_PRINT_SETTINGS,
	DX_PAGE_BREAK,
	DX_SORT_OPTIONS,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.DX_PRINT_SETTINGS = DX_PRINT_SETTINGS;

	self.pageBreakAlternatives = [];
	self.sortAlternatives = [];

	if (self.pageBreakOptions) {
		self.pageBreakAlternatives = self.pageBreakOptions.map(function mapFn(pageBreakOption) {
			switch (pageBreakOption) {
				case DX_PAGE_BREAK.NO_PAGE_BREAK:
					return {
						value: DX_PAGE_BREAK.NO_PAGE_BREAK,
						displayName: dxLocalize.get("PrintSettings.PageBreaks.Disabled"),
					};
				case DX_PAGE_BREAK.PAGE_BREAK_TITLE:
					return {
						value: DX_PAGE_BREAK.PAGE_BREAK_TITLE,
						displayName: dxLocalize.get("PrintSettings.PageBreaks.ExamTitle"),
					};
				case DX_PAGE_BREAK.PAGE_BREAK_STUDENT:
					return {
						value: DX_PAGE_BREAK.PAGE_BREAK_STUDENT,
						displayName: dxLocalize.get("PrintSettings.PageBreaks.Student"),
					};
				case DX_PAGE_BREAK.PAGE_BREAK_QUESTION:
					return {
						value: DX_PAGE_BREAK.PAGE_BREAK_QUESTION,
						displayName: dxLocalize.get("PrintSettings.PageBreaks.Question"),
					};
			}

			return null;
		});
	}

	if (self.sortOptions) {
		self.sortAlternatives = self.sortOptions.map(function mapFn(sortOption) {
			switch (sortOption) {
				case DX_SORT_OPTIONS.STUDENTS:
					return {
						value: DX_SORT_OPTIONS.STUDENTS,
						displayName: dxLocalize.get("PrintSettings.SortBy.Students"),
					};
				case DX_SORT_OPTIONS.QUESTIONS:
					return {
						value: DX_SORT_OPTIONS.QUESTIONS,
						displayName: dxLocalize.get("PrintSettings.SortBy.Questions"),
					};
			}

			return null;
		});
	}

	self.isSettingEnabled = function isSettingEnabled(setting) {
		return (self.settings & setting) > 0;
	};

	self.toggleSetting = function toggleSetting(setting) {
		if (self.isSettingEnabled(setting)) {
			self.settings -= setting;
		} else {
			self.settings += setting;
		}
	};

	self.isIdentifierSettingRequired = function isIdentifierSettingRequired() {
		// At least one option needs to be enabled
		// Returns true as long as only one option is enabled
		var optionsChecked = 0;
		if (self.isSettingEnabled(self.DX_PRINT_SETTINGS.SHOW_NAME)) {
			optionsChecked++;
		}
		if (self.isSettingEnabled(self.DX_PRINT_SETTINGS.SHOW_EMAIL)) {
			optionsChecked++;
		}
		if (self.isSettingEnabled(self.DX_PRINT_SETTINGS.SHOW_STUDENT_CODE)) {
			optionsChecked++;
		}

		if (optionsChecked > 1) {
			return false;
		}
		return true;
	};

	self.isDisabled = function isDisabled(setting) {
		// At least one option needs to be enabled
		return self.isIdentifierSettingRequired() && self.isSettingEnabled(setting);
	};
});
